import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';
import { AdminCrashreport } from './admincrashreport.page';

export const routes: Routes = [
    { path: 'admincrashreport', component: AdminCrashreport }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        AdminCrashreport
    ]

})

export class AdminCrashreportModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/admincrashreport/admincrashreport.module.ts